module.exports = __webpack_public_path__ + "img/gonetwork1_3.cb22f555.png";